export const RegexUtils = {
  // Only Alphanumeric chars with space
  charsWithNumbers: /^[a-zA-Z0-9 ]*$/,

  // Only Alphanumeric chars with space and hypen (no hyphen at start/end)
  alphaNumericWithHyphen: /^[a-zA-Z0-9\s]+(?:-[a-zA-Z0-9\s]+)*$/, // use for Tenant Name/Org Name

  // Only Chars with space
  charsWithSpace: /^[A-Za-z ]+$/,
  charsWithSpaceNoNumbersUTF8Regex: /^^[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}A-Za-z\s]+$/,

  charsWithHyphenSpaceComma: /^[A-Za-z0-9, -]+$/,
  charsWithHyphenSpaceCommaslash: /^[A-Za-z-.0-9'/, -]+$/,

  // For phone
  sortCodeRegEx: '^[0-9]{6}$',
  phoneRegEx: /^\d{7,15}$/,

  userNameUTF8Regex:
    /^(?!\s)(?![!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|])(?!.*[-@.]{2,})[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}\p{S}\p{M}\p{N}\p{P}a-zA-Z0-9!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|]+(?<!\s)(?<![-@.])$/,
  nameUTF8Regex: /^(?![\s\d])[^\s\d]?[\p{Lu}\p{L}\p{N}\p{P}\p{S}a-zA-Z\s'-]+[a-zA-Z\s'-]?[^\s]?(?<![!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|\s\d])$/,
  emailRegex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
  passwordRegex: /^(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>?])(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,

  // commons
  verificationCodeRegex: /^\d{6}$/,

  // company details
  companyHouseRegistrationNumberRegex: /^[a-zA-Z0-9]+$/,
  companyName:
    /^(?!['-\s\d])[^\s\d]?[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}\p{M}\p{N}a-zA-Z!@#$%^&*()-_=+[\]{};:'",.<>/?\\|\s\d]+[^\s]$/,

  numbersOnlyRegex: /^\d+$/,

  // tax details
  giinRegex: /^([A-NP-Z0-9]){6}\.([A-NP-Z0-9]){5}\.(LE|SL|ME|BR|SP)\.[A-Z0-9]{3}$/,
  taxIdentificationNumber: /^[A-Za-z0-9]+$/,

  //bank details
  bankName: /^[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}a-zA-Z&' -]+$/,
  swiftCodeRegex: /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/,
  ibanRegex: /^[A-Za-z0-9]*$/,

  percentageHoldingRegex: /^\d+(\.\d{1,2})?$/,
  websiteUrlRegex: /^((https?:\/\/)?(www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/\S*)?)$/,

  atLeastOneSpecialCharacterRegex: /^(?=(?:[^!@#$%^&*()_+[\]{};':"\\|,.<>?]*[!@#$%^&*()_+[\]{};':"\\|,.<>?]))[^\s]*$/,
  atLeastOneNumberRegex: /\d/,
  atLeastOneUpperCaseCharacterRegex: /^(?=.*[A-Z]).+$/,
  atLeastOneLowerCaseCharacterRegex: /^(?=.*[a-z]).+$/,
  lengthMustBeInBetween8to16: /^(.{8,16})$/,

  // address regex
  alphaNumUTF8SpaceSpecialCharsNoNumbersRegex:
    /^[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}\p{P}a-zA-Z!@#$%^&*()-_=+[\]{};:'",.<>/?\\|\s]+$/,
  alphaNumUTF8SpaceNoSpecialCharsRegex: /^[\p{Latin}\p{Cyrillic}\p{Greek}\p{Armenian}\p{Georgian}\p{Hebrew}\sa-zA-Z0-9]+$/,
  postalCodeCountriesRegex: {
    UK: /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i,
    LU: /^\d{4}$/i,
    US: /^\d{5}(-\d{4})?$/i,
  },
};
